module.exports = __webpack_public_path__ + "img/Placeholder_fichier.628a5130.jpg";